module.exports = __webpack_public_path__ + "img/PCT07.86471d3d.svg";